import { definePanel } from '@/app/definePanel';
import { ServerSettingsIcon } from '@/components/occurra/icons/ServerSettingsIcon';
import { PanelMode, PanelTheme } from '@/types/panels';

export default definePanel({
    id: 'servers',
    title: 'Servers',
    description: 'The servers of the organization, their settings and their updates.',
    icon: ServerSettingsIcon,
    // A 240px rail beside a section pane, as in camera settings. One width for every section:
    // the updates table, which lists every server in columns, sets it.
    width: { min: 480, default: 1040, max: 1440, fill: false },
    modes: [PanelMode.Settings],
    themes: PanelTheme.Any,
    order: 3.4,
    // The panel draws the header of each pane itself.
    isHeaderless: true,
    urlSyncedProps: [],
});
